const translations = {
  ar: {
    title: 'رحلتي 🗺️',
    subtitle: 'اكتشف أجمل مناطق الأردن',
    search: 'ابحث عن منطقة...',
    summer: '☀️ صيف',
    winter: '❄️ شتاء',
    spring: '🌸 ربيع',
    home: '🏠 الرئيسية',
    map: '🗺️ عرض على الخريطة',
    directions: '🚗 احصل على الاتجاهات',
    services: 'عرض الخدمات القريبة',
    photos: '📸 صور من الزوار',
    addPhoto: '📸 أضف صورة',
    loginHint: '🔑 سجل دخول لإضافة صور',
    login: '🔑 تسجيل دخول بـ Google',
    logout: 'تسجيل خروج',
    loading: '⏳ جاري تحميل الخدمات...',
    noServices: 'لا توجد خدمات قريبة',
    welcome: '👋 اختر الموسم المناسب لرحلتك',
    summerRegions: 'مناطق الصيف',
    winterRegions: 'مناطق الشتاء',
    springRegions: 'مناطق الربيع',
    distance: 'تبعد حوالي',
    fromLocation: 'كم عن موقعك',
    locating: 'جاري تحديد موقعك...',
    closeMap: '✖️ إغلاق الخريطة',
    restaurants: 'مطاعم',
    markets: 'ماركتات',
    fuel: 'محطات وقود',
    hotels: 'فنادق',
  },
  en: {
    title: 'Rihlati 🗺️',
    subtitle: 'Discover the most beautiful places in Jordan',
    search: 'Search for a place...',
    summer: '☀️ Summer',
    winter: '❄️ Winter',
    spring: '🌸 Spring',
    home: '🏠 Home',
    map: '🗺️ View on Map',
    directions: '🚗 Get Directions',
    services: 'Nearby Services',
    photos: '📸 Visitor Photos',
    addPhoto: '📸 Add Photo',
    loginHint: '🔑 Login to add photos',
    login: '🔑 Sign in with Google',
    logout: 'Sign Out',
    loading: '⏳ Loading services...',
    noServices: 'No nearby services found',
    welcome: '👋 Choose the right season for your trip',
    summerRegions: 'Summer Destinations',
    winterRegions: 'Winter Destinations',
    springRegions: 'Spring Destinations',
    distance: 'About',
    fromLocation: 'km from your location',
    locating: 'Locating you...',
    closeMap: '✖️ Close Map',
    restaurants: 'Restaurants',
    markets: 'Supermarkets',
    fuel: 'Gas Stations',
    hotels: 'Hotels',
  }
};

export default translations;
